<template>
    <div class="phone-numbers">
        <label-input
            v-for="(phone, iPhone) in myPhones.$each.$iter"
            :key="phone.key.$model"
            :label="'Phone / Location' + (phone.deleted.$model ? '' : ' *')"
            input-style="flex-wrap: wrap;"
        >
            <template v-slot:custom>
                <input type="hidden" :name="'phone_numbers[' + iPhone + '][id]'" :value="phone.$model.id">
                <input type="hidden" :name="'phone_numbers[' + iPhone + '][seq]'" :value="iPhone">
                <input-only
                    :required="true"
                    v-model="phone.phone_number.$model"
                    :disabled="phone.deleted.$model"
                    :name="'phone_numbers[' + iPhone + '][phone_number]'"
                />
                <select-only
                    :required="true"
                    v-model="phone.phone_number_type_id.$model"
                    type="select"
                    :options="phoneNumberTypes"
                    :disabled="phone.deleted.$model"
                    :name="'phone_numbers[' + iPhone + '][phone_number_type_id]'"
                />
<!--
                <select v-model="phone.phone_number_type_id">
                    <option
                        v-for="pnt in phoneNumberTypes"
                        :value="pnt.value"
                        v-text="pnt.label"
                    />
                </select>
-->
                <i
                    class="phoneControl"
                    :class="phone.deleted.$model ? 'icon-restore' : 'icon-delete'"
                    :title="(phone.deleted.$model ? 'Restore' : 'Delete') + ' phone number'"
                    @click="toggle(phone.key.$model)"
                />
                <p
                    class="help is-danger"
                    v-if="phone.$anyDirty && phone.$invalid && !phone.deleted.$model"
                    v-text="'Phone number and type are both required.'"
                    style="flex: 0 0 100%;"
                />
            </template>
        </label-input>

        <label-input label=" ">
            <template v-slot:custom>
                <i class="icon-add" @click="add" id="phoneAdd"> Add a phone number</i>
            </template>
        </label-input>
        <label-input label=" " v-if="!person.phone_numbers.minLength">
            <template v-slot:custom>
                <p
                    class="help is-danger"
                    v-text="'Provide at least one phone number.'"
                />
            </template>
        </label-input>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import InputOnly from '../../_components/form/InputOnly';
import LabelInput from '../../_components/form/LabelInput';
import SelectOnly from '../../_components/form/SelectOnly';

export default {
    components: {
        InputOnly,
        LabelInput,
        SelectOnly,
    },

    props: {
        // TODO: Limit to just phone numbers?
        person: {
            type: Object,
        },
        phoneNumberTypes: {
            type: Array,
        },
    },

    data() {
        return {
            myPhones: this.person.phone_numbers,
        };
    },

    computed: {
        nActive() {
            return this.myPhones.filter(phone => !phone.deleted).length;
        },
    },

    watch: {
        myPhones: {
            deep: true,
            handler() {
                // this.$set(this.person, 'phone_numbers', this.myPhones);
            },
        },
    },

    methods: {
        add() {
            this.myPhones.$model.push({
                id: null,
                key: uuidv4(),
                phone_number: '',
                phone_number_type_id: 1,
                deleted: false,
            })
        },

        toggle(key) {
            const i = this.myPhones.$model.findIndex(p => p.key === key);
            this.$set(this.myPhones.$model[i], 'deleted', !this.myPhones.$model[i].deleted);
        },
    },

    created() {
        // const pns = JSON.parse(JSON.stringify(this.person.phone_numbers.map(pn => {
        //     pn.key = pn.id;
        //     pn.deleted = false;
        //     return pn;
        // })));
        // this.myPhones.splice(0, this.myPhones.length, ...pns);
    },
}
</script>

<style lang="scss">
.phone-numbers {
    .icon-add {
        margin-left: 0 !important;
    }
    input.input[name^="phone_numbers"] {
        margin-top: -5px;
    }
}
</style>
